import {
  axiosDeleteRequest,
  axiosGetPaginatedRequest,
  axiosPatchRequest,
  axiosPutRequest,
  getNotificationsRoute,
} from '../api';
import { Notification, PushNotificationsRegisterDto } from './model';
import { PushNotificationsUnregisterDto } from './model/PushNotificationsUnregisterDto';

const PAGE_SIZE = 20;

export const fetchNotificationsCall = (
  xMsContinuationToken?: string,
  numrecs?: number
) => {
  return axiosGetPaginatedRequest<Notification[]>(
    `${getNotificationsRoute()}/notifications/${numrecs || PAGE_SIZE}`,
    xMsContinuationToken
  );
};

export const deleteNotificationCall = (
  notificationId: string,
  toMemberId: string
) => {
  return axiosDeleteRequest<string, void>(
    `${getNotificationsRoute()}/notification/${notificationId}/member/${toMemberId}`
  );
};

export const readNotificationCall = (
  notificationId: string,
  toMemberId: string
) => {
  return axiosPatchRequest<string, void>(
    `${getNotificationsRoute()}/notification/${notificationId}/member/${toMemberId}/read`
  );
};

export const clearNotificationsBadgeCall = async (
  notificationType?: string
) => {
  return axiosPatchRequest<string, void>(
    `${getNotificationsRoute()}/notifications/read?notificationtype=${
      notificationType ? notificationType : 'all'
    }`
  );
};

export const registerDevicePushNotifications = (
  pushNotificationsDto: PushNotificationsRegisterDto
) => {
  const res = axiosPutRequest<PushNotificationsRegisterDto, void>(
    `${getNotificationsRoute()}/push/notifications/register`,
    pushNotificationsDto
  );
  return res;
};

export const unregisterDevicePushNotifications = (
  unregisterDto: PushNotificationsUnregisterDto
) => {
  const res = axiosDeleteRequest(
    `${getNotificationsRoute()}/push/notifications/unregister`,
    unregisterDto
  );
  return res;
};
